import React from 'react';
import { ICheckItem, IListProps } from '../../../interfaces/interfaces';
import ListItem from './ListItem';

function List(props: IListProps): JSX.Element {
  const { items, isChecklist, onItemChange, className, itemClassName } = props;

  const onChange = (item: ICheckItem, isChecked: boolean) => {
    if (isChecklist && onItemChange) {
      onItemChange(item, isChecked);
    }
  };

  const sortItems = (itemsToSort: ICheckItem[]) => {
    itemsToSort.sort((a: ICheckItem, b: ICheckItem) => {
      return (a.sort || 0) - (b.sort || 0);
    });
    return itemsToSort;
  };

  return (
    <ul className={`item-list ${className || ''}`}>
      {sortItems(items).map((item: ICheckItem) => {
        return (
          <ListItem
            key={item.title}
            item={item}
            isCheckable={isChecklist}
            onChange={onChange}
            className={itemClassName}
          />
        );
      })}
    </ul>
  );
}
export default List;
